import api from 'services/api';

type TypeFetchVideo = {
  videoHashId: string;
};

type TypeFetchChapters = {
  videoHashId: string;
  channelHashId: string;
  shotId: string;
};

type TypeFetchVideoDetail = {
  videoHashId: string;
  channelHashId?: string;
};

export const fetchVideoIsShared = async (videoHashId: string): Promise<any[]> => {
  const response = await api.get(`/api/videos/${videoHashId}/shared/ `);
  return response.data;
};

export const fetchVideoTimeline = async (channelHashId: string, videoHashId: string, shotId: string): Promise<any> => {
  if (channelHashId !== 'home') {
    return await api.get(`api/channels/${channelHashId}/videos/${videoHashId}/shots/${shotId}/timelines/`);
  } else {
    return await api.get(`api/videos/${videoHashId}/shots/${shotId}/timelines/`);
  }
};

export const fetchVideo = async ({ videoHashId }: TypeFetchVideo): Promise<any> => {
  const response = await api.get(`/api/videos/${videoHashId}/info/`);
  return response.data;
};

export const fetchVideoChapters = async ({ channelHashId, videoHashId, shotId }: TypeFetchChapters): Promise<any> => {
  if (channelHashId !== 'home') {
    return await api.get(`/api/channels/${channelHashId}/videos/${videoHashId}/shots/${shotId}/chapters/`);
  } else {
    return await api.get(`api/videos/${videoHashId}/shots/${shotId}/chapters/`);
  }
};

export const fetchVideoShots = async ({ videoHashId }: TypeFetchVideo): Promise<any> => {
  const response = await api.get(`/api/videos/${videoHashId}/shots/`);
  return response.data;
};

export const fetchVideoDetail = async ({ channelHashId, videoHashId }: TypeFetchVideoDetail): Promise<any> => {
  const response = await api.get(`/api/channels/${channelHashId}/videos/${videoHashId}/`);
  return response.data;
};
